import { Expose } from "class-transformer";

export class UnassignPlanningBoardLoanUserDto {
  @Expose()
  userId: string;
}
